module.exports = __webpack_public_path__ + "img/image32.b34d8740.webp";